import { createStore, applyMiddleware, compose } from "redux";
// import thunk from "redux-thunk";
// import { routerMiddleware } from "connected-react-router";
import { createRootReducer } from "./redux";
import { createBrowserHistory } from "history";
import logger from "redux-logger";
import thunkMiddleware from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { createReducer } from "./redux/ReduxHelpers";

export const history = createBrowserHistory();
const persistConfig = {
  key: "root",
  storage,
};
const rootReducer = createRootReducer(history);
const persistedReducer = persistReducer(persistConfig, rootReducer);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureAppStore(preloadedState) {
  const store = createStore(
    rootReducer,
    preloadedState,
    composeEnhancers(applyMiddleware(thunkMiddleware, logger))
  );
  let persistor = persistStore(store);
  persistor.purge();
  console.log(persistor);
  return { store, persistor };
}
